import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import JuniorHeader from'../Component/JuniorHeader'
const SchoolHours = () => { 
    useEffect(() => {
        document.title = ' School Hours - Sacread Heart Kharagpur';  
    }, []); 
  return (
     <>
     <JuniorHeader/>
       <div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li>  Academic</li>
                 <li>School Hours</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1>School Hours</h1>
                    </div>
                </div>
                <div className="row">
                     <div className="col-lg-8 col-12 mx-auto d-block maintable">
                     <table class="table" cellspacing="0" border="0">
                     <tbody>
                     <tr> <th colspan="2">Class</th> </tr> 
                     <tr> <td width="100px">K.G. I</td> <td width="50px"> <b>7:30 A.m. to 11.30 A.m.</b></td> </tr> 
                     <tr> <td width="100px">K.G. II</td> <td width="50px"> <b>7.30 A.m to 12.00 Noon.</b></td> </tr> 
                     <tr> <td width="100px">Class I-IV</td> <td width="50px"> <b>7.30 A.m to 1.15 P.m.</b></td> </tr> 
                     <tr> <td width="100px">Tiffin Break </td> <td width="50px"><b>10.00 A.m to 10.30 A.m </b></td> </tr> 
                     <tr>
                     <th colspan="2">Assembly</th> </tr>
                      <tr><td colspan="2">Assembly begins 10 minutes before the class hours <br/>
                      Assembly is held on every Tuesday & Thursday</td></tr> 
                     </tbody>
                     </table>
                  </div>
                </div>
            </div>
        </div>
     </>
  )
}

export default SchoolHours

